"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _immutable = require("immutable");

var _underscore = require("underscore");

var _q = _interopRequireDefault(require("q"));

var _requireAsync = _interopRequireDefault(require("crm_ui/utils/requireAsync"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

function _default(modules) {
  if (modules == null) {
    modules = [];
  }

  return {
    componentDidMount: function componentDidMount() {
      var _this = this;

      this._isMounted = true;
      return modules.forEach(function (module) {
        var callback;
        var names;

        if ((0, _underscore.isObject)(module)) {
          var name = module.name;
          names = module.names;
          callback = module.callback;
          (0, _invariant.default)(name || names && (names.size || names.length), 'RequireAsync: a module name or array/iterable of names must be provided');

          if (name) {
            names = (0, _immutable.Seq)([name]);
          } else {
            names = (0, _immutable.Seq)(names);
          }
        } else if (typeof module === 'string') {
          names = (0, _immutable.Seq)([module]);
        }

        return _q.default.Promise.all(names.map(function (name) {
          (0, _invariant.default)(typeof name === 'string', 'RequireAsync: module name must be defined');
          return (0, _requireAsync.default)(name).then(function (Module) {
            if (_this._isMounted) {
              var moduleTitle = (0, _underscore.last)(name.split(/[./]/));
              return _this[moduleTitle] = Module;
            }

            return null;
          });
        }).toArray()).then(function () {
          if (callback && _this._isMounted) {
            callback = _this[callback];
            (0, _invariant.default)(typeof callback === 'function', "RequireAsync: component must define " + callback + " method");
            return callback();
          }

          return null;
        }).done();
      });
    },
    componentDidUnMount: function componentDidUnMount() {
      this._isMounted = false;
    }
  };
}

module.exports = exports.default;